import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';

const setup = (iam, store, uri) => {
  // Get GraphQL results over a network using HTTP fetch
  const httpLink = createHttpLink({
    uri,
  });

  // HTTP Auth header injection
  const authLink = setContext(async (_, { headers }) => {
    try {
      let authorizationHeader = {};
      const { user } = store.state.iam;
      if (user) {
        const token = await iam.getAccessToken();
        authorizationHeader = token ? { authorization: `Bearer ${token}` } : {};
      }
      return {
        headers: {
          ...headers,
          ...authorizationHeader,
        },
      };
    } catch (error) {
      store.dispatch('modal/error', error);
      throw error;
    }
  });

  // Create the apollo client
  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
      },
    },
    resolvers: {
      Query: {
        testLocalQuery() {
          return true;
        },
      },
    },
  });
};

export default { setup };
